import { createContext } from 'react';

/**
 * Initializes a context for sharing a company name.
 */
export const CompanyNameContext = createContext(null);
